import { render } from "./TeamDeviceCreateDialog.vue?vue&type=template&id=60c22601"
import script from "./TeamDeviceCreateDialog.vue?vue&type=script&lang=js"
export * from "./TeamDeviceCreateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__